import { render, staticRenderFns } from "./BarValue.vue?vue&type=template&id=4bcc9495&"
import script from "./BarValue.vue?vue&type=script&lang=js&"
export * from "./BarValue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports